/* Glow Edition — shared helpers for Auria (Rabehni). Add-to-cart goes through the theme's own <wrapp-hdt-pr-frm>, so the drawer + free-shipping bar update the native way. */
(function () {
  if (window.Glow) return;

  var money = function (cents) {
    var v = Math.round(cents) / 100;
    return (v % 1 ? v.toFixed(2) : String(v)).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' ج';
  };

  var toast = function (msg) {
    var t = document.querySelector('.glw-toast');
    if (!t) { t = document.createElement('div'); t.className = 'glw-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2200);
  };

  // items: [{id: variantId, quantity: 1}]
  var add = function (items, btn) {
    return new Promise(function (resolve) {
      var wrap = document.createElement('div');
      wrap.hidden = true;
      var html = '<wrapp-hdt-pr-frm><form method="post" action="/cart/add" class="hdt-contents" novalidate><output name="id" hidden></output>';
      items.forEach(function (it, i) {
        html += '<input type="hidden" name="items[' + i + '][id]" value="' + Number(it.id) + '">' +
                '<input type="hidden" name="items[' + i + '][quantity]" value="' + (Number(it.quantity) || 1) + '">';
      });
      html += '<button type="submit" name="add">add</button></form></wrapp-hdt-pr-frm>';
      wrap.innerHTML = html;
      document.body.appendChild(wrap);
      if (btn) btn.setAttribute('aria-busy', 'true');
      var done = function () { if (btn) btn.removeAttribute('aria-busy'); setTimeout(function () { wrap.remove(); }, 400); resolve(); };
      document.addEventListener('cart:change', done, { once: true });
      setTimeout(function () { if (btn && btn.getAttribute('aria-busy')) done(); }, 8000);
      requestAnimationFrame(function () {
        var form = wrap.querySelector('form');
        form.requestSubmit ? form.requestSubmit(form.querySelector('button')) : form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    });
  };

  var product = function (handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  };

  window.Glow = { money: money, toast: toast, add: add, product: product };

  // [data-glw-add="variantId"] buttons anywhere
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-glw-add]');
    if (!b) return;
    e.preventDefault();
    var card = b.closest('[data-glw-card]');
    var picked = card && card.querySelector('input[data-glw-variant]:checked');
    var id = picked ? picked.value : b.getAttribute('data-glw-add');
    add([{ id: id, quantity: 1 }], b);
  });

  // FAQ: tabs + one-open-at-a-time
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-glw-faq-tab]');
    if (!tab) return;
    var box = tab.closest('.glw-faq'); var cat = tab.getAttribute('data-glw-faq-tab');
    box.querySelectorAll('[data-glw-faq-tab]').forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
    box.querySelectorAll('details[data-cat]').forEach(function (d) { d.hidden = !(cat === 'all' || d.getAttribute('data-cat') === cat); });
  });
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!(d instanceof HTMLDetailsElement) || !d.open || !d.closest('.glw-faq')) return;
    d.closest('.glw-faq').querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
  }, true);

  // reels: play only in view
  var io = 'IntersectionObserver' in window && new IntersectionObserver(function (es) {
    es.forEach(function (en) { var v = en.target; if (en.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); } });
  }, { threshold: .6 });
  var watch = function () { if (io) document.querySelectorAll('.glw-reel video:not([data-w])').forEach(function (v) { v.dataset.w = 1; io.observe(v); }); };
  document.addEventListener('DOMContentLoaded', watch); watch();
})();
